import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { FileSchema } from "../../Schemas/File";

export interface FileListResponseBody extends IResponseBody {
  data: {
    files: FileSchema;
  };
}

export class FileVerifyRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(fileId: number) {
    return `admin/files/${fileId}/verify`;
  }

  async send(fileId: number): Promise<FileListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(fileId),
        {}
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
